import { TranslationService } from "../../../../services/TranslationService";
import { EditProps } from "../EditAction";
import { Checkbox } from "./FieldHelpers";

export const IncludeClientDueCustomerSheet = (props: EditProps) => <Checkbox text={TranslationService.translate.IncludeDueSheet} defaultValue={props.data.IncludeClientData ?? true} onChange={props.setField("IncludeClientData")} />

